// extracted by mini-css-extract-plugin
export default {"menuButton":"TableRowControlsOverlay_menuButton__9mXQ7","menu":"TableRowControlsOverlay_menu__TdMLT"};